import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const {Types, Creators} = createActions({
  foldersRequest: ['page', 'page_size', 'search', 'filter', 'sort', 'nextPage'],
  foldersSuccess: ['list'],

  folderRequest: ['id'],
  folderSuccess: ['focusRow'],
  folderReset: null,

  folderSaveRequest: ['data'],
  folderSaveSuccess: ['saveResult'],
  folderSaveReset: null,

  folderDeleteRequest: ['id'],
  folderDeleteSuccess: ['deleteResult'],
  folderDeleteReset: null,

  folderMakeDefaultRequest: ['id'],
  folderMakeDefaultSuccess: ['folderId', 'makeDefaultResult'],
  folderMakeDefaultReset: null,

  foldersReset: null,

  foldersFetchingReset: null,
})

export const FoldersTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  list: null,
  fetching: false,

  saveResult: null,
  saveFetching: false,

  deleteResult: null,
  deleteFetching: false,

  makeDefaultResult: null,
  makeDefaultFetching: false,

  page: 1,
  page_size: 12,

  focusRow: null,
})

/* ------------- Selectors ------------- */
export const FoldersSelectors = {
  getState: state => state.folders,
}

/* ------------- Reducers ------------- */

export const foldersRequest = (state, {page, page_size, search, filter, sort, nextPage}) => {
  const newState = {
    fetching: true,
  }

  page && (newState.page = page)
  page_size && (newState.page_size = page_size)

  return state.merge(newState)
}

export const foldersSuccess = (state, {list}) => {
  return state.merge({fetching: false, list})
}

export const folderRequest = (state, {id}) => {
  return state.merge({fetching: true})
}

export const folderSuccess = (state, {focusRow}) => {
  return state.merge({fetching: false, focusRow})
}

export const foldersReset = state => {
  return INITIAL_STATE
}

export const folderReset = state => {
  return state.merge({focusRow: null})
}

export const folderSaveRequest = (state, {data}) => {
  return state.merge({saveFetching: true})
}

export const folderSaveSuccess = (state, {saveResult}) => {
  const arrFoldersId = []
  let newResults = state.list?.results.map(folder => {
    arrFoldersId.push(folder.id)
    if (folder.id === saveResult.id) {
      return {...saveResult}
    } else {
      return {...folder}
    }
  })

  if (!arrFoldersId.includes(saveResult.id)) newResults = [saveResult, ...newResults]

  const newList = {...state.list, results: [...newResults]}

  return state.merge({saveFetching: false, saveResult, list: newList})
}

export const folderSaveReset = state => {
  return state.merge({saveFetching: false, saveResult: null})
}

export const folderDeleteRequest = (state, {id}) => {
  return state.merge({deleteFetching: true})
}

export const folderDeleteSuccess = (state, {deleteResult}) => {
  return state.merge({deleteFetching: false, deleteResult})
}

export const folderDeleteReset = state => {
  return state.merge({deleteFetching: false, deleteResult: null})
}

export const folderMakeDefaultRequest = (state, {id}) => {
  return state.merge({makeDefaultFetching: true})
}

export const folderMakeDefaultSuccess = (state, {folderId, makeDefaultResult}) => {
  const newResults = state.list?.results.map(folder => {
    if (folder.id === folderId) {
      return {...folder, is_default: true}
    } else {
      return {...folder, is_default: false}
    }
  })
  const newList = {...state.list, results: [...newResults]}

  return state.merge({makeDefaultFetching: false, makeDefaultResult, list: newList})
}

export const folderMakeDefaultReset = state => {
  return state.merge({makeDefaultFetching: false, makeDefaultResult: null})
}

export const foldersFetchingReset = state => {
  return state.merge({fetching: false, saveFetching: false, deleteFetching: false, makeDefaultFetching: false})
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.FOLDERS_REQUEST]: foldersRequest,
  [Types.FOLDERS_SUCCESS]: foldersSuccess,

  [Types.FOLDER_REQUEST]: folderRequest,
  [Types.FOLDER_SUCCESS]: folderSuccess,

  [Types.FOLDER_SAVE_REQUEST]: folderSaveRequest,
  [Types.FOLDER_SAVE_SUCCESS]: folderSaveSuccess,
  [Types.FOLDER_SAVE_RESET]: folderSaveReset,

  [Types.FOLDER_DELETE_REQUEST]: folderDeleteRequest,
  [Types.FOLDER_DELETE_SUCCESS]: folderDeleteSuccess,
  [Types.FOLDER_DELETE_RESET]: folderDeleteReset,

  [Types.FOLDER_MAKE_DEFAULT_REQUEST]: folderMakeDefaultRequest,
  [Types.FOLDER_MAKE_DEFAULT_SUCCESS]: folderMakeDefaultSuccess,
  [Types.FOLDER_MAKE_DEFAULT_RESET]: folderMakeDefaultReset,

  [Types.FOLDERS_RESET]: foldersReset,
  [Types.FOLDER_RESET]: folderReset,

  [Types.FOLDERS_FETCHING_RESET]: foldersFetchingReset,
})
